var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 366.259 366.259",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.479,71.073c-2.047-7.833-8.614-13.659-16.634-14.758c-50.333-6.899-101.384-10.397-151.737-10.397 c-50.352,0-101.392,3.498-151.697,10.398c-8.02,1.1-14.586,6.926-16.633,14.758c-19.704,75.403-19.704,148.711,0,224.113 c2.047,7.832,8.614,13.659,16.635,14.758c50.339,6.899,101.394,10.397,151.745,10.397c50.353,0,101.389-3.498,151.688-10.398 c8.02-1.1,14.585-6.925,16.632-14.756C371.186,219.794,371.186,146.486,351.479,71.073z M247.165,197.261l-74.357,57.131 c-3.172,2.439-7.006,3.689-10.86,3.689c-2.681,0-5.374-0.604-7.875-1.835c-6.089-3-9.942-9.198-9.942-15.986V125.999 c0-6.789,3.854-12.987,9.942-15.986c6.091-3,13.352-2.281,18.735,1.854l74.357,57.13c4.393,3.373,6.966,8.596,6.966,14.132 C254.13,188.665,251.557,193.888,247.165,197.261z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7d9dedb8419568e2f643b5e87ef6a7be.svg";
export { ForwardRef as ReactComponent };